module.exports = __webpack_public_path__ + "static/media/view department.2ce96c18.svg";